'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var thumbs = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  name: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired
}));

exports.default = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  original: _propTypes2.default.string.isRequired,
  thumbs: thumbs.isRequired
}));


//////////////////
// WEBPACK FOOTER
// ../admin-modules/build/proptypes/images.js
// module id = 1293
// module chunks = 0